function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#workplate_svg__clip0_1401_12911)",
  fill: "#787B86"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.642 5.762a2 2 0 012-2h3.753a2 2 0 012 2v3.753a2 2 0 01-2 2H4.642a2 2 0 01-2-2V5.762zM2.642 16.09a2 2 0 012-2h3.753a2 2 0 012 2v3.753a2 2 0 01-2 2H4.642a2 2 0 01-2-2V16.09z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.463 3.57a2 2 0 012.828 0l2.654 2.654a2 2 0 010 2.829l-2.654 2.654a2 2 0 01-2.828 0l-2.654-2.654a2 2 0 010-2.829l2.654-2.653z",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 16.09a2 2 0 012-2h3.753a2 2 0 012 2v3.753a2 2 0 01-2 2H14a2 2 0 01-2-2V16.09z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "workplate_svg__clip0_1401_12911"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

var SvgWorkplate = function SvgWorkplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgWorkplate;